module.exports = require("./tt.d.ts");